import { immerable } from 'immer';

import { ProductInstanceTypeModel } from './module-role';

interface IInstanceModule {
	id: number;
	title: string;
	type: ProductInstanceTypeModel;
	publicUrl: string;
}

const entityDefaults: IInstanceModule = {
	id: -1,
	title: '',
	type: ProductInstanceTypeModel.DcMarketplace,
	publicUrl: '',
};

export class InstanceModule implements IInstanceModule {
	private [immerable] = true;
	public id = entityDefaults.id;
	public title = entityDefaults.title;
	public type = entityDefaults.type;
	public publicUrl = entityDefaults.publicUrl;

	public static build(params: Partial<IInstanceModule> = {}): InstanceModule {
		const inst = new InstanceModule();
		inst.id = params.id ?? entityDefaults.id;
		inst.title = params.title ?? entityDefaults.title;
		inst.type = params.type ?? entityDefaults.type;
		inst.publicUrl = params.publicUrl ?? entityDefaults.publicUrl;

		return inst;
	}
}
